import React from 'react';

import { DynamicComponent, getBreakpointFromManor } from 'ctm-components';

import { FooterManorXs } from './footer_manor_xs';
import { FooterManorSmToLg } from './footer_manor_sm_to_lg';

const FooterManor = () => {
    const getFooter = function () {
        switch (getBreakpointFromManor()) {
            case 'xs': return <FooterManorXs />;
            case 'sm': return <FooterManorSmToLg leftSpacing="64" rightSpacing="64" />;
            case 'md': return <FooterManorSmToLg leftSpacing="80" rightSpacing="80" />;
            default: return <FooterManorSmToLg leftSpacing="16" rightSpacing="16" />;
        }
    };

    return (
        <DynamicComponent
            component={getFooter()}
        />
    );
};

export { FooterManor };
